import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { LightbulbIcon, QuoteIcon, CalendarIcon, ClockIcon, MonitorIcon, TimerIcon, CheckCircle2Icon, StarIcon } from 'lucide-react';
const ArtikelHondentaalContent = () => {
  const navigate = useNavigate();
  const trustboxRef = useRef<HTMLDivElement>(null);
  const handleCTA = () => {
    navigate('/liefdevol-communiceren-ac-adv2');
  };
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  return <>
      <div className="advertorial-content max-w-3xl mx-auto px-4 font-sans text-gray-800 pb-28" data-id="element-625">
        {/* TOP BANNER */}
        <div className="pt-6 pb-4 px-4 max-w-3xl mx-auto" data-id="element-626">
          <div className="flex items-center justify-center mb-6" data-id="element-627">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-14 object-contain" data-id="element-628" />
          </div>
          <button onClick={handleCTA} className="w-full border-2 border-blue-600 bg-blue-50 py-3 px-4 rounded-lg text-center font-bold text-blue-700 hover:bg-blue-100 transition-colors text-sm md:text-base" data-id="element-629">
            DE LIEFDEVOL COMMUNICEREN METHODE VAN HONDEN GEDRAGSEXPERT AMEE DE
            BRUIJN
          </button>
        </div>

        {/* 1. HOOFDTITEL (Hero sectie) */}
        <section className="mb-10 text-center" data-id="element-630">
          <h1 className="text-[1.6rem] md:text-3xl font-bold text-[rgb(30,64,175)] mb-6 text-center leading-snug" data-id="element-631">
            Waarom jouw hond niet luistert - en waarom jij daar zelf de oorzaak
            van bent
          </h1>
          <p className="text-blue-600 font-semibold mb-8 text-center" data-id="element-632">
            Modern onderzoek naar honden laat zien dat we op een andere manier
            met hen om moeten gaan.
          </p>
          <div className="w-full mb-2" data-id="element-633">
            <img src="https://cdn.magicpatterns.com/uploads/t8jaMNfJ3z6DxQ27njofF8/Scherm_afbeelding_2025-08-21_om_23.44.08-min_(1).png" alt="Labrador aan de lijn op straat" className="w-full h-auto rounded-lg" data-id="element-634" />
          </div>
          <p className="text-xs text-gray-400 italic mb-6" data-id="element-635">
            Soms kan één methode alles veranderen in de relatie met je hond
          </p>
          <div className="w-full h-[1px] bg-gray-200" data-id="element-636"></div>
        </section>

        {/* 2. EERSTE TEKSTBLOK */}
        <section className="mb-12" data-id="element-637">
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-638">
            Je hond springt op als er bezoek komt. Of hij blaft aan één stuk
            door. Of hij trekt zo hard aan de lijn dat wandelen geen plezier
            meer is. Je hebt het al tientallen keren gecorrigeerd. Je bent
            strenger geworden. Je hebt je stem verheven. Misschien heb je hem
            zelfs bestraft.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-639">
            En toch gebeurt het steeds weer.
          </p>
          <p className="mb-8 text-gray-800 leading-relaxed" data-id="element-640">
            Wat de meeste baasjes op dat moment denken: mijn hond wil gewoon
            niet luisteren. Maar volgens gediplomeerd hondengedragsconsultant
            Amee de Bruijn is wat er in werkelijkheid aan de hand is, iets heel
            anders.
          </p>
          <div className="w-full mb-6" data-id="element-641">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JyaDPTDobRjD5WRihmtQh/Scherm%C2%ADafbeelding_2025-08-15_om_15.32.12.png" alt="Innig moment tussen een man en zijn golden retriever die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg" data-id="element-642" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-643">
              Het moment waarop je eindelijk begrijpt wat je hond al die tijd
              probeerde te zeggen
            </p>
          </div>
        </section>

        {/* 3. TWEEDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-644">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-645">
            Je praat heel de dag met lichamelijke signalen
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-646">
            "Honden communiceren primair via lichaamstaal," legt Amee uit.
            "Blaffen en piepen zijn eigenlijk al de laatste uitingen - het punt
            waarop een hond niet meer weet hoe hij het anders moet zeggen."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-647">
            De echte communicatie zit volgens haar in veel subtielere signalen.
            Een hond die gaapte toen je hem aanraakte. Een hond die zijn gewicht
            verplaatste toen je dichter bij hem kwam. Een hond die even wegkeek
            op het moment dat de spanning opliep. Geen toevallige bewegingen,
            zegt Amee - boodschappen.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-648">
            Maar de meeste baasjes weten niet wat ze betekenen. "Niet omdat ze
            het niet willen weten," benadrukt ze, "maar omdat niemand het ze
            ooit heeft geleerd. Je wordt niet geboren met kennis van hondentaal.
            En in de meeste traditionele hondentrainingen staat het ook niet
            centraal."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-649">
            Het gevolg is dat baasjes de hele aanloop missen. Ze zien niet wat
            er opbouwt. Ze zien alleen het eindpunt - het blaffen, het springen,
            het uitvallen - en dát is het moment waarop ze ingrijpen. Met een
            correctie. Met straf.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed font-semibold" data-id="element-650">
            "Maar tegen de tijd dat een hond zover is," zegt Amee, "heeft hij al
            lang geprobeerd iets te zeggen. En niemand heeft geluisterd."
          </p>
        </section>

        {/* 4. DERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-651">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-652">
            Je stem zegt: Stop daarmee. Maar je lichaam zegt: ik keur dit goed.
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-653">
            Voor veel baasjes is dit het moment waarop alles op zijn plaats
            valt. Want het probleem is niet alleen dat baasjes hondentaal niet
            begrijpen - het probleem is ook dat baasjes zelf voortdurend
            signalen afgeven waar ze zich niet bewust van zijn.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-654">
            Amee legt via de Liefdevol Communiceren Methode een veelvoorkomende
            situatie uit: je hond springt op. Jij wordt boos. Je verheft je
            stem, je zegt streng "nee" of "af". Maar tegelijkertijd zeg je met
            je lichaam dat je zijn gedrag goedkeurt.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-655">
            "Jouw stem zegt: stop daarmee. Jouw lichaam zegt: ik keur dit goed."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-656">
            En honden kijken meer naar lichaamstaal dan naar stemgeluid. "Dus
            wat denk je welk signaal er aankomt?" vraagt Amee.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-657">
            Dit is slechts één voorbeeld. Amee beschrijft tientallen situaties
            per dag waarin hetzelfde gebeurt - waarin de bedoeling van de
            eigenaar en zijn lichaamstaal elkaar tegenspreken. En elke keer
            raakt de hond een stukje meer verward.
          </p>
        </section>

        {/* 5. VIERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-658">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-659">
            De oplossing is eenvoudiger dan je denkt
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-660">
            "Hondentaal is geen mysterie," stelt Amee. "Het is een consistent
            systeem van signalen dat te leren is."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-661">
            En zodra je het kent, gebeuren er volgens haar twee dingen tegelijk.
            Je begrijpt eindelijk wat je hond al die tijd probeerde te
            vertellen. En je leert hoe je zelf bewuster communiceert - met je
            lichaam, niet alleen met je stem.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-662">
            "Dat is het moment waarop het gedrag verandert. Niet omdat de hond
            anders wordt, maar omdat de communicatie eindelijk klopt."
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-663">
            De verwarring verdwijnt. En daarmee verdwijnt ook het gedrag dat
            zoveel frustratie veroorzaakte.
          </p>
        </section>

        {/* 6. SECTIE MET HET GEKLEURDE KADER */}
        <section className="mb-12" data-id="element-664">
          <div className="bg-blue-50 border-l-4 border-blue-700 rounded-r-lg p-8" data-id="element-665">
            <div className="flex items-center gap-3 mb-6" data-id="element-666">
              <LightbulbIcon className="w-6 h-6 text-blue-700" data-id="element-667" />
              <h2 className="text-2xl font-bold text-blue-900" data-id="element-668">
                Leer hondentaal via de Liefdevol Communiceren Methode
              </h2>
            </div>

            <p className="mb-4 text-gray-800 leading-relaxed text-lg" data-id="element-669">
              Amee de Bruijn deelt deze kennis via de Liefdevol Communiceren
              Methode — een complete aanpak voor hondeneigenaren die vastlopen
              met hun hond. Je leert welke signalen je hond gebruikt en wat ze
              betekenen. Je leert hoe je die signalen eerder herkent — voordat
              gedrag escaleert. En je leert hoe je je eigen lichaamstaal bewust
              inzet, zodat jouw boodschap ook daadwerkelijk aankomt.
            </p>

            <p className="text-blue-800 leading-relaxed text-lg font-semibold mb-4" data-id="element-670">
              Meer dan 15.000 Nederlandse en Vlaamse hondeneigenaren werkten al
              met de Liefdevol Communiceren Methode. Veel van hen zeiden
              achteraf hetzelfde: het was alsof er eindelijk ondertiteling werd
              aangezet.
            </p>

            <p className="text-gray-800 leading-relaxed text-lg mb-6" data-id="element-671">
              Start vandaag nog. De Liefdevol Communiceren Methode kan
              veranderen hoe jij en je hond de rest van jullie leven met elkaar
              communiceren.
            </p>

            <button onClick={handleCTA} className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg" data-id="element-672">
              Ontdek de Liefdevol Communiceren Methode →
            </button>
          </div>

          <div className="w-full mt-6 mb-6" data-id="element-673">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mPezTbx7aSGaxHbt8eLB8F/Scherm%C2%ADafbeelding_2025-08-15_om_15.37.25.png" alt="Vrouw in oranje trui communiceert met haar border collie in een park" className="w-full h-auto rounded-lg" data-id="element-674" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-675">
              "Via de Liefdevol Communiceren Methode leer ik mensen de
              basisgrammatica van de hondentaal," stelt Amee
            </p>
          </div>
        </section>

        {/* PARTICIPANT TESTIMONIALS */}
        <section className="mb-12" data-id="element-676">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-677">
            Wat baasjes ervaren met de Liefdevol Communiceren Methode
          </h2>

          <div className="space-y-6" data-id="element-678">
            <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-679">
              <div className="flex items-start gap-4" data-id="element-680">
                <img src="https://cdn.magicpatterns.com/uploads/fB8Dhs4wiGrDqogWAqXKm6/Scherm_afbeelding_2025-08-15_om_15.51.14.png" alt="Lenneke uit Utrecht" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-681" />
                <div data-id="element-682">
                  <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-683" />
                  <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-684">
                    "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                    chaotisch waren. Luna probeerde me de hele tijd te vertellen
                    dat ze zich onveilig voelde, maar ik interpreteerde het als
                    koppigheid. Het moment dat ik dat doorhad, veranderde
                    alles."
                  </p>
                  <p className="text-sm font-semibold text-gray-700" data-id="element-685">
                    - Lenneke uit Utrecht
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-686">
              <div className="flex items-start gap-4" data-id="element-687">
                <img src="https://cdn.magicpatterns.com/uploads/pS516JjYb2Jy2Jib3WaRmC/Scherm­afbeelding_2026-04-07_om_17.13.16.png" alt="Thomas uit Antwerpen" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-688" />
                <div data-id="element-689">
                  <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-690" />
                  <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-691">
                    "Mijn vrouw en ik keken elkaar halverwege aan. 'Daarom doet
                    hij dat!' zeiden we tegelijk. Plotseling maakten alle rare
                    gewoontes van Rex perfect zin."
                  </p>
                  <p className="text-sm font-semibold text-gray-700" data-id="element-692">
                    - Thomas uit Antwerpen
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-693">
              <div className="flex items-start gap-4" data-id="element-694">
                <img src="https://cdn.magicpatterns.com/uploads/cq9sJtJYFgjvYc8NrDV2AV/Scherm­afbeelding_2026-04-07_om_17.14.25.png" alt="Sandra uit Amsterdam" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-695" />
                <div data-id="element-696">
                  <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-697" />
                  <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-698">
                    "Het was emotioneel. Ik realiseerde me dat Buddy mij al
                    maanden probeerde iets te vertellen over zijn angst, en ik
                    dacht maar dat hij ongehoorzaam was. Ik voelde me schuldig,
                    maar ook opgelucht. Eindelijk begreep ik hem."
                  </p>
                  <p className="text-sm font-semibold text-gray-700" data-id="element-699">
                    - Sandra uit Amsterdam
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WAT IS DE LIEFDEVOL COMMUNICEREN METHODE? */}
        <section className="mb-12" data-id="element-700">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-701">
            Wat is de Liefdevol Communiceren Methode?
          </h2>
          <p className="text-gray-800 leading-relaxed" data-id="element-702">
            De Liefdevol Communiceren Methode is een complete aanpak gebaseerd
            op Natural Dog Training en de inzichten van wereldexperts zoals
            Turid Rugaas. Je leert de verborgen taal van je hond lezen én zelf
            vloeiend terugpraten — zonder dwang, straf of dominantie. Je volgt
            de methode via een online cursus op je eigen tempo, vanaf je
            telefoon, tablet of computer. Na aanschaf heb je direct en
            levenslang toegang.
          </p>
        </section>

        {/* EXPERT PROFILE */}
        <section className="mb-12" data-id="element-703">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-704">
            De expert achter de Liefdevol Communiceren Methode
          </h2>

          <div className="flex items-start mb-6" data-id="element-705">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-24 h-24 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-706" />
            <div data-id="element-707">
              <p className="text-gray-800 leading-relaxed mb-3" data-id="element-708">
                Amee de Bruijn, gediplomeerd hondengedragsconsultant & Natural
                Dog Trainer niveau 5 (Calming Signs, 2017), heeft de Liefdevol
                Communiceren Methode ontwikkeld nadat ze zag hoeveel frustratie
                ontstaat door simpele misverstanden tussen honden en hun
                baasjes.
              </p>
            </div>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-709">
            <p className="text-gray-800 leading-relaxed italic" data-id="element-710">
              "Als je begrijpt dat je hond al die tijd probeerde met je te
              communiceren, verandert je hele relatie. En die verandering wil ik
              elke hondeneigenaar gunnen."
            </p>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-711">
            <p className="text-gray-800 leading-relaxed italic" data-id="element-712">
              "Mensen vragen me altijd waarom ik deze kennis gratis deel," zegt
              Amee. "Het antwoord is simpel: omdat het basisrecht zou moeten
              zijn om je hond te begrijpen."
            </p>
          </div>
        </section>

        {/* WEBINAR TIMELINE / STAPPEN */}
        <section className="mb-12" data-id="element-713">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-714">
            Wat je leert via de Liefdevol Communiceren Methode
          </h2>

          <div className="space-y-6" data-id="element-715">
            {[{
            number: 1,
            title: 'Stap 1: Waarom dominantie averechts werkt',
            description: 'Amee legt uit waarom straffen en dominant gedrag vaak het tegengestelde effect heeft van wat je wilt bereiken, en hoe dit spanning creëert in plaats van samenwerking.'
          }, {
            number: 2,
            title: 'Stap 2: Hoe honden natuurlijk communiceren',
            description: 'Je ontdekt hoe honden in de natuur onderling communiceren en welke signalen ze gebruiken om met elkaar en hun omgeving te "praten".'
          }, {
            number: 3,
            title: 'Stap 3: Signalen herkennen en interpreteren',
            description: 'Je leert de belangrijkste lichaamstaal-signalen die elke hond gebruikt, en wat ze werkelijk betekenen in verschillende situaties.'
          }, {
            number: 4,
            title: 'Stap 4: In hun taal terugpraten',
            description: 'Hoe je terug communiceert in hun taal en wat dit betekent voor jullie dagelijkse samenwerking.'
          }, {
            number: 5,
            title: 'Stap 5: Handgebaren en kalmerende signalen',
            description: 'Amee laat zien welke concrete gebaren en signalen je direct kunt inzetten — technieken die je hond van nature begrijpt.'
          }, {
            number: 6,
            title: 'Stap 6: Samenwerken in het dagelijks leven',
            description: 'Hoe je de Liefdevol Communiceren Methode toepast in concrete situaties: aan de lijn, bij visite, thuis en onderweg.'
          }].map(step => <div key={step.number} className="flex items-start" data-id="element-716">
                <div className="flex-shrink-0 w-10 h-10 bg-[#1e40af] text-white rounded-full flex items-center justify-center font-bold mr-4 mt-1" data-id="element-717">
                  {step.number}
                </div>
                <div data-id="element-718">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-719">{step.title}</h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-720">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mt-8 rounded-r-lg" data-id="element-721">
            <p className="text-gray-800 leading-relaxed italic" data-id="element-722">
              "Het mooie is dat mensen al na de eerste stap van de Liefdevol
              Communiceren Methode anders leren kijken naar het gedrag van hun
              hond," vertelt Amee. "Ze herkennen plotseling signalen die ze
              altijd zagen maar verkeerd interpreteerden, en begrijpen hun hond
              direct beter."
            </p>
          </div>
        </section>

        {/* PRAKTISCHE INFO */}
        <section className="mb-12" data-id="element-723">
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-724">
            <div className="flex items-center gap-3 mb-6" data-id="element-725">
              <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-726" />
              <h3 className="text-xl font-bold text-gray-900" data-id="element-727">
                De Liefdevol Communiceren{' '}
                <span className="text-blue-600" data-id="element-728">Methode</span>
              </h3>
            </div>

            <div className="space-y-5 mb-8" data-id="element-729">
              <div className="flex items-center" data-id="element-730">
                <CalendarIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-731" />
                <p className="text-lg text-gray-800" data-id="element-732">
                  <span className="font-bold" data-id="element-733">Toegang:</span> Direct na aanschaf
                </p>
              </div>
              <div className="flex items-center" data-id="element-734">
                <ClockIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-735" />
                <p className="text-lg text-gray-800" data-id="element-736">
                  <span className="font-bold" data-id="element-737">Tempo:</span> Volledig op eigen
                  tempo
                </p>
              </div>
              <div className="flex items-center" data-id="element-738">
                <MonitorIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-739" />
                <p className="text-lg text-gray-800" data-id="element-740">
                  <span className="font-bold" data-id="element-741">Apparaat:</span> Telefoon, tablet
                  of computer
                </p>
              </div>
              <div className="flex items-center" data-id="element-742">
                <TimerIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-743" />
                <p className="text-lg text-gray-800" data-id="element-744">
                  <span className="font-bold" data-id="element-745">Toegang:</span> Levenslang,
                  inclusief updates
                </p>
              </div>
              <div className="flex items-center" data-id="element-746">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-747" />
                <p className="text-lg text-gray-800" data-id="element-748">
                  <span className="font-bold" data-id="element-749">Prijs:</span> €127 (normaal €197)
                </p>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6" data-id="element-750">
              <p className="font-bold text-gray-900 mb-2 italic" data-id="element-751">Belangrijk:</p>
              <p className="text-gray-600 leading-relaxed" data-id="element-752">
                Met 365 dagen niet-goed, geld-terug garantie. Geen risico.
              </p>
            </div>

            <button onClick={handleCTA} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-753">
              START MET DE LIEFDEVOL COMMUNICEREN METHODE — DIRECT TOEGANG
            </button>
          </div>
        </section>

        {/* BONUS SECTION */}
        <section className="mb-12" data-id="element-754">
          <div className="w-full mb-6" data-id="element-755">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad in de namiddagzon" className="w-full h-auto rounded-lg" data-id="element-756" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-757">
              Een stressvrij leven voor je hond. En voor jou.
            </p>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-xl p-8" data-id="element-758">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-759">
              Inbegrepen bij de Liefdevol Communiceren Methode:
            </h3>

            <p className="text-gray-800 leading-relaxed mb-6 text-lg" data-id="element-760">
              Volledige online cursus in 7 modules, 30 dagen gratis
              community-toegang, 8 printbare stappenplannen (waarde: €44) en
              levenslange, onbeperkte toegang.
            </p>

            <div className="space-y-5 mb-8" data-id="element-761">
              <div className="flex items-start" data-id="element-762">
                <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-763" />
                <span className="text-gray-800 text-lg" data-id="element-764">
                  Direct toegang na aanschaf
                </span>
              </div>
              <div className="flex items-start" data-id="element-765">
                <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-766" />
                <span className="text-gray-800 text-lg" data-id="element-767">
                  Volg op je eigen tempo, op elk apparaat
                </span>
              </div>
              <div className="flex items-start" data-id="element-768">
                <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-769" />
                <span className="text-gray-800 text-lg" data-id="element-770">
                  Levenslange toegang, ook bij updates
                </span>
              </div>
            </div>

            <button onClick={handleCTA} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-771">
              JA, IK WIL DE LIEFDEVOL COMMUNICEREN METHODE — DIRECT STARTEN
            </button>
          </div>
        </section>

        {/* TRUSTPILOT REVIEWS */}
        <section className="mb-12" data-id="element-772">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-773">
            Wat cursisten over ons zeggen
          </h2>
          <div ref={trustboxRef} className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-id="element-774">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-775">
              Trustpilot
            </a>
          </div>
        </section>

        {/* WHY DIFFERENT */}
        <section className="mb-12" data-id="element-776">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-777">
            Waarom dit anders is dan andere trainingsmethoden
          </h2>

          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-778">
            Traditionele hondentraining draait om gehoorzaamheid: je hond leren
            doen wat jij wilt. Amee's methode draait om begrip en samenwerken:
            Je hond leren begrijpen en hoe hij je zorgt dat hij jou begrijpt.
          </p>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-779">
            <p className="text-gray-800 leading-relaxed italic" data-id="element-780">
              "Het verschil is enorm," legt ze uit. "Bij training probeer je
              gedrag te forceren. Als je leert communiceren dan begrijp je
              elkaar en kan je samenwerken met je hond. Bovendien wordt je hond
              er veel relaxter van."
            </p>
          </div>
        </section>

        {/* FAQ SECTIONS */}
        <section className="mb-12" data-id="element-781">
          <div className="mb-10" data-id="element-782">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-783">
              "Is er een specifiek moment waarop het kwartje valt?"
            </h2>

            <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-784">
              Er is een specifiek moment in de Liefdevol Communiceren Methode
              dat Amee het "omslagpunt" noemt. Meestal in stap 2, wanneer ze een
              aantal misvattingen over dominantie uit de wereld helpt.
            </p>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-785">
              <p className="text-gray-800 leading-relaxed italic" data-id="element-786">
                "Dan hoor ik van baasjes dat het kwartje valt," vertelt ze. "Ze
                sturen me berichten als 'OMG, daarom doet hij dat!' of 'Dit
                verklaart alles!' Dat is het moment waarop ze overschakelen van
                problemen zien naar communicatie begrijpen."
              </p>
            </div>
          </div>

          <div className="mb-10" data-id="element-787">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-788">
              "Wat zeggen mensen één week na de start van de Liefdevol
              Communiceren Methode?"
            </h2>

            <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-789">
              De echte test van de Liefdevol Communiceren Methode komt in de
              eerste dagen na de start. Kunnen mensen de nieuwe inzichten
              toepassen? Maken ze echt verschil?
            </p>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-4 rounded-r-lg" data-id="element-790">
              <p className="text-gray-800 leading-relaxed italic" data-id="element-791">
                "Binnen drie dagen waren onze wandelingen compleet veranderd,"
                vertelt Jeroen uit Rotterdam. "In plaats van Max corrigeren ging
                ik luisteren naar wat hij probeerde te zeggen. Nu zijn
                wandelingen ontspannen in plaats van stressvol."
              </p>
            </div>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-792">
              <p className="text-gray-800 leading-relaxed italic" data-id="element-793">
                Emma uit Gent: "Het grappige is dat Mila niet veranderd is - ik
                begrijp haar gewoon beter. Waardoor zij zich ook rustiger voelt.
                Het is een opwaartse spiraal."
              </p>
            </div>
          </div>
        </section>

        {/* TRANSFORMATION SUMMARY */}
        <section className="mb-12" data-id="element-794">
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-795">
            Lisa herkent dit moment: "Het kwartje viel toen Amee uitlegde hoe
            honden vanuit hun natuur gewend zijn met elkaar om te gaan. Ik
            begreep dat Benny helemaal niet koppig was - hij begreep mij gewoon
            niet, net zoals ik hem niet begreep. We hadden gewoon langs elkaar
            heen gecommuniceerd."
          </p>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-796">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-797">
              Wat deelnemers ontdekken:
            </h3>

            <div className="space-y-5 mb-8" data-id="element-798">
              <div className="flex items-start" data-id="element-799">
                <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-800" />
                <p className="text-lg text-gray-800" data-id="element-801">
                  <span className="font-bold" data-id="element-802">Dat onrustige gedrag?</span> Vaak
                  mentale vermoeidheid, niet fysieke energie.
                </p>
              </div>
              <div className="flex items-start" data-id="element-803">
                <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-804" />
                <p className="text-lg text-gray-800" data-id="element-805">
                  <span className="font-bold" data-id="element-806">
                    Die korte blikken naar de deur?
                  </span>{' '}
                  Je hond probeert je mee te nemen naar iets interessants.
                </p>
              </div>
              <div className="flex items-start" data-id="element-807">
                <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-808" />
                <p className="text-lg text-gray-800" data-id="element-809">
                  <span className="font-bold" data-id="element-810">
                    Dat wegkijken wanneer je hem roept?
                  </span>{' '}
                  Respect, geen negeren.
                </p>
              </div>
            </div>

            <p className="text-lg text-gray-800 leading-relaxed italic" data-id="element-811">
              Via de Liefdevol Communiceren Methode leer je eindelijk wat je
              hond al die tijd probeerde te zeggen.
            </p>
          </div>

          <p className="text-xl text-gray-900 font-bold text-center mt-8" data-id="element-812">
            Soms kan één methode alles veranderen in de relatie met je hond
          </p>
        </section>

        {/* FINAL CTA */}
        <section className="mb-12" data-id="element-813">
          <div className="bg-red-50 border-2 border-red-400 rounded-lg p-4 mb-6 text-center" data-id="element-814">
            <p className="text-red-700 font-bold text-lg" data-id="element-815">
              ⚠️ TIJDELIJKE AANBIEDING ⚠️
            </p>
          </div>

          <div className="bg-white border-2 border-green-500 rounded-lg p-8 text-center" data-id="element-816">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-817">
              Leer vandaag nog "Liefdevol Communiceren Methode"
            </h2>

            <p className="text-lg text-gray-700 mb-2" data-id="element-818">
              Direct toegang • Op je eigen tempo
            </p>

            <div className="inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold text-2xl mb-6" data-id="element-819">
              €127
            </div>

            <p className="text-sm text-gray-600 mb-6" data-id="element-820">
              365 dagen geld-terug garantie
            </p>

            <button onClick={handleCTA} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-5 px-8 rounded-lg transition-colors text-xl mb-6 animate-pulse" data-id="element-821">
              JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN — START DE LIEFDEVOL
              COMMUNICEREN METHODE
            </button>

            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-822">
              Van frustratie naar begrip, van gissen naar weten, van reageren
              naar communiceren
            </p>

            <div className="flex items-center justify-center" data-id="element-823">
              <div className="flex mr-2" data-id="element-824">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-825" />)}
              </div>
              <span className="text-sm font-semibold text-gray-700" data-id="element-826">
                Meer dan 15.000 baasjes gingen je voor met de Liefdevol
                Communiceren Methode
              </span>
            </div>
          </div>

          <p className="text-center text-lg font-semibold text-gray-800 mt-8" data-id="element-827">
            Want soms kan één methode alles veranderen.
          </p>
        </section>

        {/* CHAT TESTIMONIALS */}
        <section className="mb-12" data-id="element-828">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-829">
            Meer reacties van deelnemers
          </h2>

          <div className="space-y-3 mb-6" data-id="element-830">
            {[{
            initial: 'L',
            name: 'Liset',
            time: '21:29',
            text: 'Super bedankt. Was boeiend en leerzaam.',
            color: 'bg-purple-500'
          }, {
            initial: 'L',
            name: 'Linda',
            time: '21:39',
            text: 'leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :))) aangenaam verast. Dankjewel voor de masterclass',
            color: 'bg-blue-500'
          }, {
            initial: 'K',
            name: 'Karin',
            time: '21:40',
            text: 'Heel erg bedankt, het was heel leerzaam',
            color: 'bg-green-500'
          }, {
            initial: 'A',
            name: 'Annemieke',
            time: '21:40',
            text: 'heel erg bedankt voor de masterclass! groetjes, Annemieke',
            color: 'bg-pink-500'
          }, {
            initial: 'C',
            name: 'Corrie',
            time: '21:40',
            text: 'Bedankt voor je heldere uitleg! Fijne avond',
            color: 'bg-orange-500'
          }].map((testimonial, index) => <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-831">
                <div className="flex items-start" data-id="element-832">
                  <div className={`w-8 h-8 ${testimonial.color} text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0 text-sm`} data-id="element-833">
                    {testimonial.initial}
                  </div>
                  <div className="flex-1" data-id="element-834">
                    <div className="flex items-center justify-between mb-1" data-id="element-835">
                      <span className="font-semibold text-gray-900 text-sm" data-id="element-836">
                        {testimonial.name}
                      </span>
                      <span className="text-xs text-gray-500" data-id="element-837">
                        {testimonial.time}
                      </span>
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-838">{testimonial.text}</p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-white border border-gray-300 rounded-lg p-5" data-id="element-839">
            <div className="border-b border-gray-200 pb-3 mb-3" data-id="element-840">
              <p className="text-sm text-gray-600" data-id="element-841">
                <span className="font-semibold" data-id="element-842">Jessica</span> aan mij
              </p>
            </div>
            <p className="font-semibold text-gray-900 mb-3" data-id="element-843">Hi Amee,</p>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line text-sm" data-id="element-844">
              {'Super, het is gelukt. Dankjewel!\n\nIk wilde nog mijn complimenten geven voor de training. Ik heb menig training gevolgd en vond die van jou echt wel de beste. Ben benieuwd naar de cursussen!\n\nGroeten, Jessica'}
            </p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="border-t border-gray-200 pt-8 pb-24 text-sm text-gray-600" data-id="element-845">
          <div className="flex items-start mb-6" data-id="element-846">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-16 h-16 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-847" />
            <div data-id="element-848">
              <p className="font-semibold mb-2" data-id="element-849">
                Amee de Bruijn is gediplomeerd hondengedragsconsultant niveau 5,
                opgeleid bij Calming Signs in Koningslust (2017).
              </p>
              <p className="mb-4" data-id="element-850">
                "Natuurlijk heb ik ook verdere begeleiding voor mensen die nog
                meer willen leren, maar via de Liefdevol Communiceren Methode
                geef ik baasjes een stevige basis die direct toepasbaar is."
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6" data-id="element-851">
            <p className="text-xs text-gray-500 mb-4 leading-relaxed" data-id="element-852">
              <strong data-id="element-853">Meta Advertising Disclaimer:</strong> Deze website maakt
              gebruik van Meta Pixel voor advertentiedoeleinden. Dit betekent
              dat informatie over uw bezoek aan deze website wordt gedeeld met
              Meta (Facebook) om gerichte advertenties te kunnen tonen. Door
              gebruik te maken van deze website gaat u akkoord met het gebruik
              van cookies en vergelijkbare technologieën voor analytische en
              advertentiedoeleinden. Deze pagina is een advertorial voor
              Stressless Dogs. Stressless Dogs is een onafhankelijk bedrijf en
              is op geen enkele wijze verbonden aan of onderdeel van Meta
              (voorheen Facebook). Deze advertentie wordt getoond via het Meta
              advertentieplatform, maar Meta is niet verantwoordelijk voor de
              inhoud of diensten aangeboden door Stressless Dogs.
            </p>

            <p className="text-xs text-center text-gray-500" data-id="element-854">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
          </div>
        </footer>
      </div>

      {/* STICKY BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-855">
        <div className="max-w-3xl mx-auto px-4 py-2 text-center" data-id="element-856">
          <p className="text-sm text-gray-700 mb-2" data-id="element-857">
            Direct toegang • Levenslang beschikbaar • kortingsactie verloopt op{' '}
            {new Date().toLocaleDateString('nl-NL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </p>
          <button onClick={handleCTA} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors text-base" data-id="element-858">
            LIEFDEVOL COMMUNICEREN METHODE (bekijk aanbieding)
          </button>
        </div>
      </div>
    </>;
};
export function ArtikelHondentaalPage() {
  return <ArtikelHondentaalContent data-id="element-859" />;
}